import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Time = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Time" {...props}>
    <path d="M6.09863 3.68164C6.53111 2.32745 8.47624 2.30658 8.9375 3.65137L8.97852 3.79004L12.6201 18.3574L15.5439 9.2627L15.5908 9.13477C16.1044 7.89554 17.8979 7.9247 18.3711 9.17969L18.4141 9.30957L19.5469 13.2744C19.6696 13.7036 20.0624 14 20.5088 14H22C22.5522 14 22.9999 14.4478 23 15C22.9999 15.5522 22.5522 16 22 16H20.5088C19.1694 16 17.992 15.112 17.624 13.8242L16.9434 11.4434L13.9883 20.6377C13.5264 22.0742 11.4706 22.0068 11.1045 20.543L7.5459 6.30762L6.3291 11.665C6.01861 13.0308 4.80395 14 3.40332 14H2C1.44777 14 1.00009 13.5522 1 13C1.00008 12.4478 1.44776 12 2 12H3.40332C3.87017 12 4.27537 11.6769 4.37891 11.2217L6.06055 3.82227L6.09863 3.68164Z" fill="#000" />
  </StyledIcon>
));

Time.displayName = 'Time';

export { Time };
